<template>
<div>
<v-app>
<resizable-page>
  <template v-slot:table="tableProps">
  <v-card>
    <v-card-title>
      
        <v-btn
              color="primary"
              dark
              class="ma-2"
              @click="addData"
              v-if="role.create"
            >
              Add Parking
            </v-btn>
        <v-menu>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            class="ma-2"
            v-bind="attrs"
            v-on="on"
          >
            Export To XLS
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <downloadExcel
                    class = "btn"
                    :fields="field_export"
                    :worksheet="worksheetName"
                    :name="fileName"
                    :fetch= "()=>{return dataExportBefore('all')}"
                    
                  >
                    All Record
             </downloadExcel>
          </v-list-item>
          <v-list-item>
            <downloadExcel
                    class = "btn"
                    :data="exportDisplayedPage"
                    :fields="field_export"
                    :worksheet="worksheetName"
                    :name="fileName"
                  >
                    Displayed record
             </downloadExcel>
          </v-list-item>
          <v-list-item>
            <downloadExcel
                    class = "btn"
                    :fields="field_export"
                    :worksheet="worksheetName"
                    :name="fileName"
                    :fetch= "()=>{return dataExportBefore('filter')}"
                  >
                    All filtered record
                  </downloadExcel>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-spacer></v-spacer>
      <div class="d-flex">
        <v-select
        style=" max-width: 150px;"
          :items="option_filter"
          label="Select"
          v-model="searchCategory"
          @change="search=''"
           item-text="text"
          item-value="value"
        
          class="ma-2"
        hide-details
        >
        </v-select>
      <v-text-field
        :disabled="!searchCategory"
        v-model="search"
        label="Search"
          class="ma-2"
        single-line
        hide-details
      >
      </v-text-field>
        <v-btn :disabled="!search" class="mt-5"  small color="primary" @click="searchButton"> <v-icon>mdi-magnify</v-icon> </v-btn>
        <v-btn v-if="searchValue" class="mt-5 ml-1" dark small color="red" @click="clearSearchButton">Clear</v-btn>
    </div>
    </v-card-title>
    <v-data-table
      mobile-breakpoint
      :headers="headers"
      :items="table"
      
      :loading="loadTable"
      loading-text="Loading... Please wait"
      @current-items="getFiltered"
      ref="vTable"
      :height="tableProps.tableHeight"
      fixed-header
      :options.sync="options"
      :server-items-length="totalDataTable"
      :page="page"
      :pageCount="numberOfPages"
      :footer-props="{'items-per-page-options':[5,15, 30, 50, 100]}"
    >

     <template v-slot:[`item.parking_line_status`]="{ item }">
       <span v-if="item.parking_line_status==0">Masuk</span>
       <span v-if="item.parking_line_status==1">Pindah</span>
       <span v-if="item.parking_line_status==2">Keluar</span>
     </template>

     <template v-slot:[`item.parking_category`]="{ item }">
       {{ item.parking_category.parking_line_name }}
     </template>

     <template v-slot:[`item.parking_vehicle`]="{ item }">
       {{ item.parking_vehicle.vehicle_plate_no }}
     </template>



     <template v-slot:[`item.actions`]="{ item }">
      <!-- <v-icon
        small
        class="mr-2"
        @click="editData(item.id)"
        v-if="role.update"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteConfirmation(item.id)"
         v-if="role.delete"
      >
        mdi-delete
      </v-icon> -->
        <v-menu  offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            x-small
            v-bind="attrs"
            v-on="on"
            
          >
            <v-icon dark x-small>
              mdi-format-list-bulleted-square
            </v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-if="role.update" @click="editData(item.id)">
            <v-list-item-title x-small>Edit</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="role.delete" @click="deleteConfirmation(item.id)">
            <v-list-item-title >Delete</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
    
    </v-data-table>
  </v-card>
    </template>
  </resizable-page>
  </v-app>
</div>
</template>

<script>
import vuetify from '@/plugins/vuetify'
import Swal from "sweetalert2";
import JsonExcel from "vue-json-excel";
import { ResizablePage } from "@/components";

  export default {
    components: {
    downloadExcel: JsonExcel,ResizablePage
  },
    vuetify,
    data () {
      return {
        searchValue:null,
        searchCategory:null,
        option_filter: [ { text: 'Parking No', value: 'parking_no' }
          ],
        page: 1,
        totalDataTable: 0,
        numberOfPages: 0,
        loadTable: true,
        role: "",
        search: '',
        options: {},
        headers: [
          {
            text: 'Parking Category',
            align: 'start',
            value: 'parking_category',
          },
          { text: 'Plate No', value: 'parking_vehicle' },
          { text: 'Status', value: 'parking_line_status' },
          { text: 'Updated At', value: 'updated_at', align: 'center'},
          { text: 'Actions', value: 'actions', align: 'center', sortable: false },
        ],
        table: [],
        worksheetName: "test",
        fileName:"test.xls",
        exportDisplayedPage:[],
        exportAllFitered:[],
        exportAll:[],
        field_export: {
         'no': 'no',
        'test' : 'test',
        'created_at' : 'created_at',
        'updated_at' : 'updated_at'
        },
      }
    },
    
    watch: {
    options: {
      handler() {
        if( !this.mounted){
          this.getList();
        }
      },
    },
    deep: true,
  },
    async mounted() {
      //get list role dan permission current user 
      this.role = await this.$store.getters["role_permission/route_filter"];
      
    this.getList();
    this.mounted = false
    },
     methods: {
       // ambil data yang dibutuhkan
    async getList() {
      this.loadTable= true
      const { page, itemsPerPage,sortBy,sortDesc } = this.options;
      console.log(this.options)
      let pageNumber = page;
      
      
      var query = {"page":{number:pageNumber,size:itemsPerPage}}

      if(sortBy.length!=0){
        var  sort=sortBy[0]
        if(sortDesc[0]){
          sort="-"+sortBy[0]
        }
        query.sort = sort
      }

      if(this.searchValue && this.searchCategory){
        
        if(query.filter){
          Object.assign(query.filter, {[this.searchCategory]:this.searchValue});
        }
        else{
          query.filter = {[this.searchCategory]:this.searchValue}
        }
      }
    
      await this.$store.dispatch("workshop_parking/list",query);
      // if (
      //   (await this.$store.getters["role/list"]) &&
      //   (await this.$store.getters["role/list"].length) != 0
      // ) {
        this.table = await this.$store.getters["workshop_parking/list"];
        var pageMeta  = await this.$store.getters["workshop_parking/page"];
      // }
      // else{
      //   this.table = []
      // }
      console.log(pageMeta)
      this.totalDataTable = pageMeta.total
      this.numberOfPages = pageMeta['to']
      this.loadTable= false
    },
    searchButton(){
       this.options.page = 1;
      this.searchValue = this.search
      this.getList()
    },
    clearSearchButton(){
       this.options.page = 1;
      this.searchValue = null
      this.search = null
      this.searchCategory = null
      this.getList()
    },

    getFiltered(data){
    this.exportDisplayedPage = this.dataExport(data)
    // if(this.$refs.vTable){
    //   this.exportAllFitered = this.dataExport(this.$refs.vTable.$children[0].filteredItems)
    // }
    // else{
    //   this.exportAllFitered = this.dataExport(this.table)
    // }
    },

    async dataExportBefore(type){
      if(this.table.length!=0){
        
      console.log("ewww")
        if(type=="all"){
          await this.$store.dispatch("workshop_parking/list");
          return this.dataExport(await this.$store.getters["workshop_parking/list"]);
        }
        else if(type=="filter"){

          var query = {}

            if(this.searchValue && this.searchCategory){
        
        if(query.filter){
          Object.assign(query.filter, {[this.searchCategory]:this.searchValue});
        }
        else{
          query.filter = {[this.searchCategory]:this.searchValue}
        }
      }
          
            await this.$store.dispatch("workshop_parking/list",query);
             return this.dataExport(await this.$store.getters["workshop_parking/list"]);
        }
      }
      
    },

     
    // fungsi tombol direct ke add page
    addData() {
      // panggil add page
    this.$router.push({name: 'Add Parking'});
    },

    // fungsi tombol direct ke edit page
    editData(id) {
      // panggil edit page
      this.$router.push({ name: 'Edit Parking', params: { id: id } })
    },

  
    // validasi delete data
    deleteConfirmation(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You wont be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.deleteData(id);
        }
      });
    },

     // fungsi delete
    async deleteData(id) {
      try {
        // kirim data ke api
        await this.$store.dispatch("workshop_parking/destroy", id)
        // panggil alert success
        await this.$store.dispatch("alerts/success", "test data delete successfully.")
        //await this.getList();
        var indexOptionTable = this.table.findIndex(p => p.id ==  id)
           this.table.splice(indexOptionTable, 1)
      } catch (e) {
        // panggil alert error
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong!"
        );
      }
    },

    //fungsi untuk mengubah data yang siap di export data ke xls, saat dipanggil di awal dan dipanggil berulang kali di fungsi filter
      dataExport(data){
       return data.map((v,index) => ({...v, no: index+1}))
      
     
      }
     },
  }
</script>
<style>
.v-application--wrap {
  min-height: unset;
}
.v-list-item__title {
    font-size: 0.8rem;
}
</style>